module.exports = __webpack_public_path__ + "img/mtbank_slide_1.7cb70ea9.jpg";